import {
    queryPddDetail,
    getBrandRequireRule,
    queryPddCategoryProperties,
    editPddDetail,
    editPddDetail2,
    pddBatchUpdateCategory,
    queryPddSpecList,
    getPddGroupSpecNames,
    queryPddCountryList,
    queryPddSpecId,
    uploadPddFileSpace,
    carouselVideo,
    editPddCarouselVideo,
    createPddRaterialImage,
    deletePddRaterialImage,
    getPddRaterialImage,
    uploadPddFile,
    getSearchPropertyValue,
    queryPddDetailSupplier,
    queryPddRelationInfo,
    queryPddCategoryPropertiesForKeywords,
    queryApplyBrandConfig,
    saveBatchTempConf,
    queryBatchDetail,
    batchPublishItem,
    saveBatchTempPrice,
    pddGetSkuList,
    queryPddBrandList
  } from '@/api/prod/center'

import store from '@/store'

import { _filterInvalidImg } from './kuaishou.js'

// 获取默认店铺参数
function _getShopId() {
  return store.getters.shops_getCategoryPropShopId('pdd') || 83101;
}

// 获取拼多多平台数据
export function getPddDetail(data) {
    return queryPddDetail(data).then(res => {
      if (res.result === 1) {
        return pddDataMap(res.data)
      }
      return null;
    })
  }
// 获取拼多多平台数据(供销商小店版)
export function getPddDetailSupplier(data) {
    return queryPddDetailSupplier(data).then(res => {
      if (res.result === 1) {
        return pddDataMap(res.data)
      }
      return null;
    })
  }
// 拼多多数据映射
export function pddDataMap(data, isRequest) {
    let skuList = _.cloneDeep(data.skuList || []);
    if (skuList && skuList.length > 0) {
      skuList = skuList.map(item => {
        return isRequest ? {
          ...item,
          skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : [])
        } : {
          ...item,
          skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : []
        }
      })
    }
    let carouselGallery = [], detailGallery = [], itemPropValues = [], imageUrl = [];
    if (!isRequest) {
      try {
        if (data.carouselGallery) {
          carouselGallery = JSON.parse(data.carouselGallery);
        }
        if (data.detailGallery) {
          detailGallery = JSON.parse(data.detailGallery);
        }
        if (data.imageUrl) {
          imageUrl = /^\[/.test(data.imageUrl) ? JSON.parse(data.imageUrl) : [data.imageUrl];
        }
        if (data.itemPropValues) {
          itemPropValues = JSON.parse(data.itemPropValues);
          itemPropValues = itemPropValues.filter(it => !!it.refPid)
        }
      } catch(e) {
        console.error(e);
      }
    }
    const resData =  isRequest ? {
      ...data,
      skuList: skuList,
      categoryIds: data.categoryIds.join(','),
      goodsCategory: data.categoryIds[0] || '',
      lastCategory: data.categoryIds[data.categoryIds.length-1] || '',
      categoryLeafId: data.categoryIds[data.categoryIds.length-1] || '',
      carouselGallery: JSON.stringify(data.carouselGallery.filter(url => !!url && typeof url === 'string')),
      detailGallery: JSON.stringify(data.detailGallery.filter(url => !!url && typeof url === 'string')),
      packageLabelGallery: JSON.stringify(data.packageLabelGallery.filter(url => !!url && typeof url === 'string')),
      specifications: JSON.stringify(data.specifications ? data.specifications : []),
      imageUrl: JSON.stringify([data.imageUrl1, data.imageUrl3].filter(img => !!img.content)),
      itemPropValues: JSON.stringify(data.itemPropValues),
      isRefundable: data.promise.isRefundable,
      isFolt: data.promise.isFolt,
      badFruitClaim: data.promise.badFruitClaim,
      deliveryType: data.promise.deliveryType ,
      lackOfWeightClaim: data.promise.lackOfWeightClaim,
      quanGuoLianBao: data.promise.quanGuoLianBao,
      zhiHuanBuXiu: data.promise.zhiHuanBuXiu,
      privacyDelivery: data.promise.privacyDelivery,
      twoPiecesDiscount: data.twoPiecesDiscount * 10 || 0,
      shopBrandConf: JSON.stringify(data.shopBrandConf ? data.shopBrandConf : []),
      // carouselVideoInfo: JSON.stringify(data.carouselVideoInfo || []),
      carouselVideoVo: data.carouselVideoVo || null,
      carouselVideoId: data.carouselVideoId || null,
    } : {
      ...data,
      skuList: skuList,
      categoryIds: (data.categoryIds || '').split(',').filter(id => !!id),
      carouselGallery: carouselGallery.filter(url => !!url && typeof url === 'string'), // 商品轮播图
      detailGallery: detailGallery.filter(url => !!url && typeof url === 'string'),
      packageLabelGallery: data.packageLabelGallery ? (Array.isArray(data.packageLabelGallery) ? data.packageLabelGallery : JSON.parse(data.packageLabelGallery)).filter(url => !!url && typeof url === 'string') : [],
      specifications: data.specifications ? JSON.parse(data.specifications) : [],
      imageUrl: imageUrl, //商品活动素材图
      imageUrl1: imageUrl.find(({materialType}) => materialType === 1) || {},
      imageUrl3: imageUrl.find(({materialType}) => materialType === 3) || {},
      itemPropValues: itemPropValues, // 类目属性值
      countryId: data.countryId == 0 ? '' : data.countryId,
      groupRequiredCustomerNum: data.groupRequiredCustomerNum || 2,
      sizeType: data.sizeType || 1,
      goodsType: data.goodsType || 1,
      secondHand: data.secondHand || 0,
      isPreSale: data.isPreSale || 0,
      shipmentLimitSecond: (data.shipmentLimitSecond === null || data.shipmentLimitSecond === undefined) ? (48*60*60) : data.shipmentLimitSecond,
      promise: {
        isRefundable: data.isRefundable,
        isFolt: data.isFolt,
        badFruitClaim: data.badFruitClaim,
        deliveryType: data.deliveryType,
        lackOfWeightClaim: data.lackOfWeightClaim,
        quanGuoLianBao: data.quanGuoLianBao,
        zhiHuanBuXiu: data.zhiHuanBuXiu,
        privacyDelivery: data.privacyDelivery,
      },
      twoPiecesDiscount: data.twoPiecesDiscount / 10 || 0,
      primitiveTwoPiecesDiscount: data.twoPiecesDiscount / 10 || 0,
      templateConfig: data.templateConfig ? JSON.parse(data.templateConfig) : [],
      shopBrandConf: data.shopBrandConf ? JSON.parse(data.shopBrandConf) : [],
      // carouselVideoInfo: JSON.parse(data.carouselVideoInfo || "[]"),
      carouselVideoVo: data.carouselVideoVo ? { ...data.carouselVideoVo } : null,
      carouselVideoId: data.carouselVideoId || null,
    };
    if (isRequest) {
      // if (resData.isPreSale) {// 如果是预售，承诺发货时间不传
      //   delete resData.shipmentLimitSecond;
      // }
      delete resData.promise;
      delete resData.imageUrl1;
      delete resData.imageUrl3;
      if (!(resData.goodsType == 2 || resData.goodsType == 3)) {
        resData.countryId = 0;
      }
    }
    return resData;
  }
  
  // 拼多多平台类目属性查询
  export function getPddCategoryProperties(data, shopId, opts = {}) {
    return queryPddCategoryProperties({
      ...data,
      shopId: shopId || _getShopId(),
    }, opts).then(res => {
      if (res.result === 1 && res.data) {
        return {
          goodsPropertiesRule: res.data.goodsPropertiesRule,
          twoPiecesDiscountRule: res.data.twoPiecesDiscountRule,
          goodsServiceRule: res.data.goodsServiceRule,
        };
      }
      return null;
    })
  }
  /*
   * 拼多多获取品牌必填规则 
   * @export
   * @param {any} leafCategoryId 类目ID 
   * @param {any} shopIds 店铺ID
   * @returns {}
  * */
  export function getPddBrandRequireRule(data) {
    return getBrandRequireRule(data).then(res => {
      if (res.result === 1) {
        return res.data
      } else {
        return false
      }
    })
  }
  
  /**
   * 根据关键词查询拼多多类目属性值
   * @param {*} data 参数
   * @param {*} shopId 店铺ID
   * @returns []
   */
  export function getPddCategoryPropertiesNew(data, shopId) {
    return queryPddCategoryPropertiesForKeywords({
      ...data,
      shopId: shopId || _getShopId(),
    }).then((res) => {
      if (res.result === 1 && res.data) {
        return res.data
      }
      return [];
    })
  }
  
  export function getApplyBrandConfig(data, params) {
    return queryApplyBrandConfig(data, params).then(res => {
      if (res.result === 1) {
        return res.data || [];
      }
      return false;
    })
  }
  export function getPddBrandList(data, params) {
    return queryPddBrandList(data, params).then(res => {
      if (res.result === 1) {
        return res.data || [];
      }
      return false;
    })
  }
  
  export function editPddInfo(data) {
    return editPddDetail(pddDataMap(data, true)).then(res => {
      if (res.result === 1) {
        return true;
      }
      return false;
    })
  }
  export function editPddInfo2(data,expandParams) {
    let params = {
      itemInfo:{...pddDataMap(data, true)},
      ...expandParams
    }
    return editPddDetail2(params).then(res => {
      if (res.result === 1) {
        return true;
      }
      return false;
    })
  }


  // 批量修改类目
export function batchPddCategory(data) {
    return pddBatchUpdateCategory(data).then(res => {
      if (res.result === 1) {
        return true
      } else {
        return false
      }
    })
  }
// 获取拼多多规格名列表
export function getPddSpecList(data) {
  return queryPddSpecList({
    ...data,
    shopId: _getShopId()
  }).then(res => {
    if (res.result === 1) {
      return res.data;
    }
  })
}
export function getGroupSpecNames(data) {
  return getPddGroupSpecNames(data).then(res => {
    if (res.result === 1) {
      return res.data;
    }
  })
}
  
export function getPddCountryList(data) {
    return queryPddCountryList({
      ...data,
      shopId: _getShopId()
    }).then(res => {
      if (res.result === 1) {
        return res.data;
      }
    })
  }
  
  // 获取拼多多规格id
export function getPddSpecId(data) {
  return queryPddSpecId({
    ...data,
    shopId: _getShopId()
  }).then(res => {
    if (res.result === 1) {
      return res.data;
    }
  })
}

// 上传图片
export function uploadFile(data = {}) {
  return uploadPddFile({
    ...data,
    shopId: _getShopId()
  }).then(res => {
    if (res.result === 1 && res.data) {
      return res.data.goodsImageUploadResponse && res.data.goodsImageUploadResponse.imageUrl;
    }
    return '';
  })
}
// 上传图片到图片空间
export function uploadFileSpace(data = {}) {
  return uploadPddFileSpace({
    ...data,
    shopId: _getShopId()
  }).then(res => {
    if (res.result === 1 && res.data && !res.errorResponse) {
      return res.data.goodsFilespaceImageUploadResponse;
    }
    return null;
  })
}
// 上传拼多多轮播视频到店铺
export function uploadCarouselVideo(data = {}) {
  return carouselVideo(data).then(res => {
    if (res.result === 1) {
      return true;
    }
  })
}
// 编辑拼多多轮播视频
export function editCarouselVideo(data = {}) {
  return editPddCarouselVideo(data).then(res => {
    if (res.result === 1) {
      return res.data || null;
    }
  })
}

// 商品素材创建接口
export const createRaterialImage = function(data = {}) {
  return createPddRaterialImage(data).then(res => {
    if (res.result === 1) {
      return res.data;
    }
  })
}
// 商品素材删除接口
export const deleteRaterialImage = function(data = {}) {
  return deletePddRaterialImage(data).then(res => {
    if (res.result === 1) {
      return true;
    }
    return false;
  })
}
// 商品素材获取接口
export const getRaterialImage = function(data = {}) {
  return getPddRaterialImage(data).then(res => {
    if (res.result === 1) {
      return res.data;
    }
  })
}
// 类目属性-品牌搜索接口
export const searchPropertyValue = function(data = {}) {
  return getSearchPropertyValue({
    ...data,
    shopId: _getShopId()
  }).then(res => {
    if (res.result === 1) {
      return res.data;
    }
  })
}
// 获取外部绑定关系
export const getRelationInfo = function(data = {}) {
  return queryPddRelationInfo(data).then(res => {
    if (res.result === 1) {
      return res.data
    }
    return null;
  })
}

// 批量铺货相关API
// 注意：目前拼多多平台可能还没有实现批量铺货功能，这里提供占位方法
export const saveBatchTempConfPdd = (data) => {
  return saveBatchTempConf({data,platform:'pdd'}).then(res => {
    if(res.result === 1) {
      return res
    }
    return false
  })
}

export const queryBatchDetailPdd = (data) => {
  return queryBatchDetail({data,platform:'pdd'}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}

export const batchPublishItemPdd = (data) => {
  return batchPublishItem({data,platform:'pdd'}).then(res => {
    if(res.result === 1) {
      return res
    }
    return false
  })
}

export const saveBatchTempPricePlatForm = (data) => {
  return saveBatchTempPrice({data,platform:'pdd'}).then(res => {
    if(res.result === 1) {
      return res.data
    }
    return false
  })
}

export const batchPddGetSkuList = (data) => {
  return pddGetSkuList(data).then(res => {
    if(res.result === 1) {
      return res
    }
    return false
  })
}
